import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import { useTranslation } from 'react-i18next';
import ImgIconComp from '../../imgcomp';
import KrClusterPopup from './kr-cluster-popup.component';
import { reactLoader, removeReactLoader, constructNestedKRPayload } from "../../../utils/common.js";
import GoalServices from "../../../services/goal.services";
import DeleteCommonModal from '../../../components/deleteCommonModal.component';

type clusterProps ={
    arrowClass: string,
    iconClass: string,
    popupClass: string,
    updateKRStates: () => void,
    metric ?: any,
    actions ?: any,
    clusterCount ?: string,
    clusterData ?:any,
    onlyMetEdit ?:boolean,
    isChildKr ?:boolean,
    childKrDuration ?: any,
    saveNestedKRs: (data:any, index:any, action:any) => void,
    goal_id ?: string,
    nestedKrIndex ?: any,
    fromParentKr ?: boolean,
    closeKrRightPanel ?: any,
    display_nested_kr ?: boolean,
    nested_krs ?: any
};

const KrCluster = (props: clusterProps) => {
    const {arrowClass='', iconClass='', popupClass='', updateKRStates, metric, actions, clusterCount,clusterData, onlyMetEdit} = props
    const [clusterFlag, setClusterFlag] = useState(false);
    const [clusterItem, setClusterItem] = useState('false');
    const [clusterClick, setClusterClick] = useState('');
    const [clusterItemToSave, setclusterItemToSave] = useState([]);
    const nodeRef = useRef<HTMLDivElement>(null);
    const [confirmPopup, setconfirmPopup] = useState(false);
    const GoalServicesInstance = new GoalServices();

    const onClusterClick = (e) => {
        if(!clusterFlag) {
            GoalServicesInstance.getClusterFireEvent({type: 'KR_CLUSTER_VIEWED', source: metric && metric.id ? 'KR_EDIT' : 'KR_SIMPLE_CREATE'})
            let totalKRs = $('.kritems').length;
            let clickedKR = $(e.target).parents().eq(4).attr('data-rbd-draggable-id');
            let lastKR = $('.kritems').last().attr('data-rbd-draggable-id')
            if (clickedKR == lastKR || totalKRs == 0) {
                $("#mainAddGoalDiv").css('padding-bottom', '75px');
            }
        }
        setClusterClick('ovalClicked');
        setClusterFlag(!clusterFlag);
        setClusterItem(e.currentTarget.parentNode.parentNode.dataset.rbdDraggableId);
    }

    React.useEffect(() => {
        if(clusterFlag) {
            let temp = document.getElementsByClassName('kritems')[document.getElementsByClassName('kritems').length - 1]; 
            let krItem = temp instanceof HTMLElement && temp.dataset.rbdDraggableId;
            if(clusterItem == krItem) {
                $('.newKrAdd').css('margin-bottom','150px')
            }
        } else {
            $('.newKrAdd').css('margin-bottom','')
        }
    }, [clusterFlag]);

    const handleClickOutside = (e) => {
        if (nodeRef && !nodeRef.current.contains(e.target)) {
            setClusterFlag(false);
            setClusterClick('');
            $("#mainAddGoalDiv").css('padding-bottom', '0');
        }
    }

    React.useEffect(() => {
        window.addEventListener("click", handleClickOutside, true);
        return () => {
          window.removeEventListener("click", handleClickOutside, true);
        }
    }, []);

    const clusterSaveItems =() => {
        saveItems(clusterItemToSave, '');
    }
    
    const saveItems = (item, id) => {
        setclusterItemToSave(item)
        if(id) {
            setconfirmPopup(true);
        } else {
            let params : any = {};
        
            let goalId = metric.goal_id;
            if(props.goal_id) {
                goalId = props.goal_id
            }
            if (typeof goalId !== "undefined") {
                let krId = "";
                if (typeof metric !== "undefined" && typeof metric["id"] !== "undefined") {
                    params.id = metric["id"];
                    krId = params.id;
                }
                params.source = 11;
                params.mirror_kr_id = item.id;
                params.real_owner = item.real_owner ? item.real_owner : metric.owner;
                params["nested_krs"] = constructNestedKRPayload(props);
                let metricMirror = [item];
                if(props.isChildKr && (props.fromParentKr == undefined || props.fromParentKr == true)) {
                    params.duration = props.childKrDuration;
                    params.real_owner_fullname = item.real_owner_fullname;
                    params.real_owner_pic = item.real_owner_picture;
                    params.metricMirror = metricMirror;
                    params.name = metricMirror && metricMirror[0] ? metricMirror[0].name :"";
                    if(props.metric.parent){
                        params.parent = props.metric.parent;
                    }
                    let action= "add";
                    if(krId != '' || props.nestedKrIndex != undefined) {
                        action = 'update';
                    }
                    props.saveNestedKRs(params,props.nestedKrIndex, action);
                } else {
                    reactLoader(true);
                    if(props.metric.parent){
                        params.start_date = props.childKrDuration.start ;
                        params.end_date = props.childKrDuration.end;
                        params.parent = props.metric.parent;
                    }
                    GoalServicesInstance.addEditKr({ goalId: goalId, metric: params }).then(
                        response => {
                            removeReactLoader();
                            setconfirmPopup(false);
                            setclusterItemToSave([]);
                            if (response.data) {
                                let result = response.data.data;
                                if(!onlyMetEdit) {
                                    if(result.parent){
                                        actions.addUpdateNestedKr(result)
                                    }else{
                                        if (krId) {
                                            actions.editNewKr(krId, response.data.data);
                                        } else {
                                            actions.addNewKr(response.data.data);
                                        }
                                    }
                                    updateKRStates();
                                }
                                closeKrRightPane();
                            }
                        }
                    );
                }
                
            }
        }
    }
    
    const exitDeleteModal = () => {
        setconfirmPopup(false);
    }

    const closeKrRightPane = () => {
        if (document.getElementById("mySidenasSingleEdit") || document.getElementById("mySidenas")) {
            if(document.getElementById("mySidenas") && document.getElementById("mySidenas").innerHTML != '') {
                ReactDOM.unmountComponentAtNode(document.getElementById("mySidenas"));
            } else {
                if(props.closeKrRightPanel != '' && !props.fromParentKr && props.isChildKr) {
                    props.closeKrRightPanel(metric.id);
                }
                ReactDOM.unmountComponentAtNode(document.getElementById("mySidenasSingleEdit"));
                if($('.goal-metric-table[data-test=krRowComponent]').length > 0) {
                    window.MyGoalContainer.updateGoalItems({ action: 'edit', goalId: metric.goal_id,metricId: metric.id ? metric.id : '' });
                }
            }
        }
        $(".goalPopupNew").css("overflow", "initial");
        return overflowHiddenFunction(false); // check this function
    }
   
    const { t } = useTranslation();
    
    return (
        <>
        <div className={`oval ${iconClass}`} ref={nodeRef} style={{verticalAlign: 'top'}} onClick={(e) => onClusterClick(e)}>
            <div className={`krCluster  ${clusterClick}`}>
                <span className="clusterCount">{clusterCount || metric.clusterCount}</span>
                {/* <img src=""
                    srcset="img/icon-tip-lightbulb@2x.png 2x,
                            img/icon-tip-lightbulb@3x.png 3x"
                    class="Icontip-lightbulb"/> */}
                <ImgIconComp id="kr_cluster_1x" width='24' height='24' class='icontipLightbulb'/>
            </div>
            {clusterFlag && <KrClusterPopup arrowClass={arrowClass} popupClass={popupClass} saveItems={saveItems} metric={metric} clusterData={clusterData} />}
        </div>
        {confirmPopup && (
            <DeleteCommonModal
                exitDeleteModal={exitDeleteModal}
                deleteItems={clusterSaveItems}
                id=""
                title={t("Save key result with New Data Type")}
                deleteContentOne=""
                deleteContentSecondParam=""
                deletefirstTitle=""
                deleteContentSecond={t("Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.")}
                buttonText={t("Save")}
                btnStyle={{ display: 'inline-block' }}
                controlStyle={{
                    'deleteCancel' : { display: 'inline-block' }
                }}
            />
        )}
        </>
    );
}
export default KrCluster;
